const ALLOWED_TAGS = [
    'b',
    'i',
    'u',
    's',
    'strike',
    'a',
    'p',
    'br',
    'span',
    'strong',
    'em',
    'div',
    'ul',
    'ol',
    'li',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'blockquote',
    'code',
    'pre',
    'del',
    'hr',
    'table',
    'thead',
    'tbody',
    'tr',
    'th',
    'td',
];
/** `data-attachment-index` helps resolve `#attachment-n` when indexing file-only attachments in the editor. */
const ALLOWED_ATTRS = {
    a: ['href', 'title', 'data-attachment-index', 'data-attachment-fullname'],
    span: ['data-action'],
};

/**
 * Sanitize HTML for safe display in chat messages. Allows only formatting and link tags.
 * @param {string} html
 * @returns {string}
 */
export function sanitizeHtml(html) {
    if (!html || typeof html !== 'string') return '';
    if (typeof document === 'undefined') return html.replace(/<[^>]+>/g, '');
    const doc = document.implementation.createHTMLDocument('');
    const div = doc.createElement('div');
    div.innerHTML = html;
    const walk = (node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        const tag = node.tagName?.toLowerCase();
        if (!ALLOWED_TAGS.includes(tag)) {
            const parent = node.parentNode;
            if (parent) {
                while (node.firstChild) parent.insertBefore(node.firstChild, node);
                parent.removeChild(node);
            }
            return;
        }
        // Strip all attributes except those explicitly allowed per tag (e.g. href/title on <a>).
        // This removes VS Code / browser paste styles (black backgrounds, syntax colors) from <span>, <div>, <pre>, etc.
        const allowed = ALLOWED_ATTRS[tag] ?? [];
        if (node.attributes) {
            for (const a of [...node.attributes]) {
                if (allowed.includes(a.name.toLowerCase())) continue;
                node.removeAttribute(a.name);
            }
        }
        [...node.childNodes].forEach(walk);
    };
    [...div.childNodes].forEach(walk);
    return div.innerHTML;
}
